/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
import { TextField, ToggleButtonGroup } from "@mui/material";
import MUIDataTable from "mui-datatables";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import DoneIcon from "@mui/icons-material/Done";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PropTypes from "prop-types";
import { useState } from "react";
import FormsModal from "./FormsModal";
import { postData } from "../Services/postData";
import { enumUrl } from "../Utils/utils";
import ConfirmModal from "./ConfirmModal";
import { deleteData } from "../Services/deleteData";
import Lang from "../Utils/lang";
import { useNavigate } from "react-router-dom";

const lang = Lang.getInstance();

function ValidateInvalidateTable({
  setForms,
  forms,
  value,
  index,
  isValidated,
}) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [editForm, setEditForm] = useState(null);
  const [password, setPassword] = useState("");
  const [deleteForm, setDeleteForm] = useState(null);
  const notifySuccess = (message) => toast.success(message);
  const notifyError = (message) => toast.error(message);

  /**
   *
   */
  function handleClose() {
    setOpen(false);
  }

  /**
   *
   * @param {*} event
   * @param {*} form
   */
  function handleOpen(event, index) {
    setOpen(true);
    setEditForm(forms.forms[index]);
  }

  /**
   *
   */
  async function handleSubmit() {
    editForm.personalData.address.street = editForm.personalData.address.street
      ? editForm.personalData.address.street.label
        ? editForm.personalData.address.street.label
        : editForm.personalData.address.street
      : "";
    editForm.personalData.buildingAddress.sc = editForm.personalData
      .buildingAddress.sc
      ? editForm.personalData.buildingAddress.sc.label
        ? editForm.personalData.buildingAddress.sc.label
        : editForm.personalData.buildingAddress.sc
      : "";
    await postData(`${enumUrl.form}/${editForm._id}`, editForm)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          handleClose();
          notifySuccess("Datele au fost salvate cu success!");
          window.location.reload();
        }
      })
      .catch((err) => {
        handleClose();
        notifyError(err.message);
      });
  }

  /**
   *
   */
  async function validateSubmit() {
    let form = Object.assign({}, editForm);
    form.isValidated = true;
    await postData(`${enumUrl.form}/${form._id}`, form)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          setOpenConfirmModal(false);
          notifySuccess("Formularul a fost validat!");
          window.location.reload();
        }
      })
      .catch((err) => {
        setOpenConfirmModal(false);
        notifyError(err.message);
      });
  }

  /**
   *
   */
  async function deleteSubmit() {
    const user = {
      username: localStorage.getItem("userName"),
      password: password,
    };
    try {
      const response = await postData(enumUrl.login, user);
      if (response.data) {
        await deleteData(`${enumUrl.form}/${deleteForm._id}`)
          .then((res) => {
            setOpenConfirmModal(false);
            setDeleteForm(null);
            notifySuccess("Formularul a fost șters!");
            window.location.reload();
          })
          .catch((err) => {
            setOpenConfirmModal(false);
            notifyError(err.message);
          });
      }
    } catch (err) {
      if (err.response.status === 401)
        notifyError("Neautorizat! Parolă incorectă");
    }
  }

  //header
  const formHeaders = [
    {
      label: "Nume",
      name: "personalData",
      options: {
        sort: false,
        customBodyRender: (personalData) => personalData.fullName,
      },
    },
    {
      label: "CNP/CIF",
      name: "personalData",
      options: {
        sort: false,
        customBodyRender: (personalData) =>
          personalData.CNP !== "" ? personalData.CNP : personalData.CIF,
      },
    },
    {
      label: "Tip colectare",
      name: "systemDataCollection",
      options: {
        sort: false,
        customBodyRender: (systemDataCollection) =>
          systemDataCollection.collectionType,
      },
    },
    {
      label: "Tip evacuare",
      name: "systemDataTreatment",
      options: {
        sort: false,
        customBodyRender: (systemDataTreatment) =>
          systemDataTreatment.evacuationType,
      },
    },

    {
      label: `Opțiuni`,
      name: "Optiuni",
      options: {
        setCellHeaderProps: () => ({
          align: "center",
        }),
        setCellProps: () => ({
          align: "center",
        }),
        filter: false,
        sort: false,

        empty: true,
        customBodyRenderLite: (index) => {
          return (
            <div style={{ marginTop: -10, marginBottom: -10 }}>
              <ToggleButtonGroup exclusive aria-label="text alignment">
                <VisibilityIcon
                  style={{
                    margin: "0px 10px",
                    cursor: "pointer",
                  }}
                  onClick={(e) => handleOpen(e, index)}
                />
                <DeleteIcon
                  style={{
                    margin: "0px 10px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setOpenConfirmModal(true);
                    setDeleteForm(forms.forms[index]);
                  }}
                />
                {isValidated ? (
                  ""
                ) : (
                  <>
                    <DoneIcon
                      style={{
                        margin: "0px 10px",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setOpenConfirmModal(true);
                        setEditForm(forms.forms[index]);
                      }}
                    />
                    <span
                      style={{
                        margin: "0px 10px",
                      }}
                    >
                      Validează
                    </span>
                  </>
                )}
              </ToggleButtonGroup>
            </div>
          );
        },
      },
    },
  ];

  function getTableOptions() {
    const responsive = "standard";
    return {
      selectableRows: "none",
      viewColumns: false,
      responsive: responsive,
      rowsPerPageOptions: [10, 20, 50, 100],
      confirmFilters: true,
      filter: false,
      download: false,
      print: false,
      textLabels: {
        body: {
          noMatch: "Nu a fost găsit nici un rezultat",
        },
      },
      count: forms.formsNumber,
      rowsPerPage: forms.perPage,
      page: forms.page,
      search: true,
      serverSide: true,
      sort: true,
      onChangePage: (page) => {
        setForms({ ...forms, page: page });
        if (forms.search)
          navigate(
            `/?isValidated=${isValidated}?page=${page + 1}?perPage=${
              forms.perPage
            }?search=${forms.search}`
          );
        else
          navigate(
            `/?isValidated=${isValidated}?page=${page + 1}?perPage=${
              forms.perPage
            }`
          );
        window.scrollTo(0, 0);
      },
      onChangeRowsPerPage: (numberOfRows) => {
        setForms({ ...forms, perPage: numberOfRows });
        if (forms.search)
          navigate(
            `/?isValidated=${isValidated}?page=${
              forms.page + 1
            }?perPage=${numberOfRows}?search=${forms.search}`
          );
        else
          navigate(
            `/?isValidated=${isValidated}?page=${
              forms.page + 1
            }?perPage=${numberOfRows}`
          );
        window.scrollTo(0, 0);
      },
      onSearchChange: async (search) => {
        if (search) {
          setForms({ ...forms, search: search });
          navigate(
            `/?isValidated=${isValidated}?page=${forms.page + 1}?perPage=${
              forms.perPage
            }?search=${search}`
          );
        } else {
          navigate(
            `/?isValidated=${isValidated}?page=${forms.page + 1}?perPage=${
              forms.perPage
            }`
          );
          setForms({ ...forms, search: null });
        }
      },
      onSearchClose: async () => {
        navigate(
          `/?isValidated=${isValidated}?page=${forms.page + 1}?perPage=${
            forms.perPage
          }`
        );
        setForms({ ...forms, search: null });
      },
    };
  }

  return (
    <>
      {value === index ? (
        <MUIDataTable
          title={""}
          data={forms.forms}
          columns={formHeaders}
          options={getTableOptions()}
        />
      ) : (
        ""
      )}
      {open ? (
        <FormsModal
          form={editForm}
          open={open}
          setForm={setEditForm}
          handleClose={handleClose}
          handleSubmit={handleSubmit}
        />
      ) : (
        ""
      )}
      {openConfirmModal ? (
        <ConfirmModal
          handleSubmit={deleteForm ? deleteSubmit : validateSubmit}
          open={openConfirmModal}
          handleClose={() => {
            setOpenConfirmModal(false);
            setDeleteForm(null);
          }}
          title={
            deleteForm
              ? "Sunteți sigur că doriți să ștergeți acest formular?"
              : "Sunteți sigur că doriți să validați acest formular?"
          }
        >
          {deleteForm ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <TextField
                label={lang.get("password")}
                type="password"
                name="password"
                placeholder="Introduceți parola pentru confirmare"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{ margin: "10px 0px", minWidth: 350 }}
              />
            </div>
          ) : (
            ""
          )}
        </ConfirmModal>
      ) : (
        ""
      )}
      <ToastContainer />
    </>
  );
}

export default ValidateInvalidateTable;

ValidateInvalidateTable.propTypes = {
  setForms: PropTypes.func,
  forms: PropTypes.object,
  value: PropTypes.number,
  index: PropTypes.number,
  isValidated: PropTypes.bool,
};
